export default class drags {
  constructor() {
    $('.drg').each(function(){
      var t = this;
      t.dropOffPos = { x : 0, y : 0 };
      t.movePos = { x : 0, y : 0 };
      t.prevPos = { x : 0, y : 0 };
      $(t).unbind('mousedown mouseup mousemove');
      $(t).on('mousedown', (e) => {
        console.log(e);
        if(!$(e.target).is('input')) {
          if(e.type=='touchstart'){
            e = e.touches[0];
          } else {
            e.preventDefault();
            e = e.originalEvent;
          }
          t.startPos = {
            x: e.screenX,
            y: e.screenY,
          };
          // console.log(t.startPos);
          t.prevPos = {
            x : t.movePos.x,
            y : t.movePos.y,
          };
          window.navdrag = t;
        }
      });
    });

    $(document).on('mousemove', function(e){
      if(window.navdrag) {
        let t = window.navdrag;
        if(e.type=='touchmove'){
          e = e.touches[0];
        } else {
          e = e.originalEvent;
        }
        let diff = {
          x: (e.screenX - t.startPos.x),
          y: (e.screenY - t.startPos.y),
        };
        let x = diff.x + t.prevPos.x;
        let y = diff.y + t.prevPos.y;
        // console.log(x,y);
        $(t).css({
          'transform' : 'translate3d('+x+'px, '+y+'px, 0)'
        });
        t.movePos = {
          x : x,
          y : y,
        };

        // console.log((Math.abs(diff.x),Math.abs(diff.y)));

        if((Math.abs(diff.x) + Math.abs(diff.y)) > 3){
          // if(e.type=='touchmove') e.preventDefault();
          window.preventClick = true;
        }
      }
    });

    $(document).on('mouseup', function(){
      setTimeout(function(){
        window.preventClick = false;
        window.navdrag = false;
      }, 50);
    });
  }
}
